<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">{{$route.meta.title}}</span></div>
		<router-view/>
	</app-content>
</template>

<script>
/**
 * 该组件作为模板设置模块的索引页面，
 * 主要用于展示页面标题并渲染子路由视图。
 */
	export default {
		name: "TemplateIndex"
	}
</script>

<style scoped>

</style>